import {Typed} from "app/stimulus/typed-stimulus";
import {ActionEvent, Controller} from "@hotwired/stimulus";
import {createHTMLElementFromString} from "app/utils/dom";
import {componentsLoader} from "app/service/components-loader";
import {isActionEvent} from "app/stimulus/stimulus-utils";

export default class extends Typed(Controller<HTMLElement>, {
    values: {
        maxItemIndex: Number,
    },
    targets: {
        bankRowTemplate: HTMLTemplateElement,
        row: HTMLElement,
        bankAccountsContainer: HTMLElement,
        isDeposit: HTMLInputElement,
    },
})
{
    public addBankAccount(): void {
        if (!this.hasBankAccountsContainerTarget) {
            return;
        }
        let index = this.hasMaxItemIndexValue ? this.maxItemIndexValue : 0;
        index = index + 1;
        this.maxItemIndexValue = index;
        const html = this.bankRowTemplateTarget.innerHTML.replace(/__name__/g, index.toString());
        const element = createHTMLElementFromString(html);
        componentsLoader.load(element);
        if (this.hasBankAccountsContainerTarget) {
            this.bankAccountsContainerTarget.appendChild(element);
        }
    }

    public removeBankAccount(name: string): void;
    public removeBankAccount(event: ActionEvent): void;
    public removeBankAccount(firstArg: any): void {
        let name: string | undefined = undefined;
        if (isActionEvent(firstArg)) {
            name = firstArg.params.name;
        } else if (typeof firstArg === 'string') {
            name = firstArg;
        }
        if (name === undefined) {
            throw new Error('Name is required to remove bank account');
        }
        name = name.toString();
        for (const row of this.rowTargets) {
            if (row.dataset.name === name) {
                row.remove();
                return;
            }
        }
    }

    public onIsDepositValueChange(event: Event): void {
        const checkbox = event.target;
        if (!(checkbox instanceof HTMLInputElement)) {
            throw new Error('Event target is not an HTMLInputElement');
        }
        if (checkbox.type !== 'checkbox') {
            throw new Error('Event target is not a checkbox');
        }
        if (!checkbox.checked) {
            return;
        }
        for (const otherCheckbox of this.isDepositTargets) {
            if (otherCheckbox === checkbox || !otherCheckbox.checked) {
                continue;
            }
            otherCheckbox.checked = false;
            otherCheckbox.dispatchEvent(new Event('change', {bubbles: true}));
        }
    }
}
